'use client';

import Link from 'next/link';
import { useBasePath } from '../navigation/base-path';
import { S3Image } from './s3-image';

interface TrendInfoCardProps {
  trendId: string;
  name: string;
  description?: string | null;
  imageUrl?: string | null;
  clickable?: boolean;
  /** Override the default Link-to-trend-page behavior. When provided,
   * the card renders as a button calling this handler instead of
   * routing — used on PC web where the trend page is replaced by a
   * modal opened in place. */
  onClick?: () => void;
}

export function TrendInfoCard({
  trendId,
  name,
  description,
  imageUrl,
  clickable = false,
  onClick,
}: TrendInfoCardProps) {
  const basePath = useBasePath();
  const content = (
    <div className="flex items-center gap-[9px] rounded-xl bg-[#2a2c31] p-2">
      {imageUrl && (
        <div className="h-16 w-16 shrink-0 overflow-hidden" style={{ borderRadius: 8 }}>
          <S3Image
            src={imageUrl}
            alt={name}
            width={64}
            height={64}
            className="h-full w-full object-cover"
          />
        </div>
      )}
      <div className="flex min-w-0 flex-1 flex-col justify-center gap-1.5">
        <p className="text-base text-white" style={{ letterSpacing: '-0.4px', lineHeight: 1.56 }}>
          {name}
        </p>
        {description && (
          <p className="line-clamp-2 text-[10px] leading-tight text-white">{description}</p>
        )}
      </div>
    </div>
  );

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className="block w-full text-left">
        {content}
      </button>
    );
  }

  if (clickable) {
    return <Link href={`${basePath}/trends/${trendId}`}>{content}</Link>;
  }

  return content;
}
